import { DocumentData, getDocs, query, QueryDocumentSnapshot, where, } from "firebase/firestore";
import { DataAccessService } from "./basic.service";

class PlayersDAService extends DataAccessService {

    constructor(collectionName: string) {
        super(collectionName)
    }

    async getPlayersCollection(docs: QueryDocumentSnapshot<DocumentData>[]) {

        const players = []

        for (const document of docs) {
            const d = document.data();
            const {ref, id} = document
            if (d.primePlayerId) {
                const docSnap = await this.getById(d.primePlayerId);
                if (docSnap.exists()) {
                    players.push({ ...d, primePlayer: docSnap.data(), id, ref });
                }
            } else {
                players.push({ ...d, id, ref });
            }
        }
        return players
    }

    async mScreenConfigGet(id: string) {

        const mScreen = []

        const querySnapshot = await getDocs(query(this.getCollection(), where('primePlayerId', '==', id)));
        if (!querySnapshot.empty) {
          for (const document of querySnapshot.docs) {
            mScreen.push({ ...document.data(), id: document.id });
          }
        }
        return mScreen
    }
}

let collectionPrefix = ''
if (process.env.VUE_APP_MODE == 'dev') {
    collectionPrefix = 'test_'
}
const collectionName =  'players'

export default new PlayersDAService([ collectionPrefix, collectionName ].join(''));